"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactMainInfo = ContactMainInfo;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
var _ContactName = require("./ContactName");
var styles = _interopRequireWildcard(require("./styles.module.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонент для указания основной информации о контакте
 *
 * Адаптивный
 * В малой (до 374px) мобильной версии не выводятся иконки около имени,
 * а все элементы выстраиваются вертикально и центрируются
 */
function ContactMainInfo(_ref) {
  let {
    title,
    name,
    href,
    target,
    onNameClick,
    nameIcons,
    NameHeadingComponent,
    vertical,
    qualityInfo
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['container'], deviceType === 'phone' && styles['mobile'], vertical && styles['vertical'])
  }, /*#__PURE__*/React.createElement(_uiKit.Overline, {
    color: "gray60_100",
    display: "block"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles['name-container']
  }, /*#__PURE__*/React.createElement(_ContactName.ContactName, {
    as: NameHeadingComponent,
    href: href,
    target: target,
    onClick: onNameClick
  }, name), nameIcons && /*#__PURE__*/React.createElement("div", {
    className: styles['name-icons']
  }, nameIcons)), qualityInfo);
}